__turbopack_context__.v({
  "actionLink": "QualityScore-module__3B8Ida__actionLink",
  "container": "QualityScore-module__3B8Ida__container",
  "header": "QualityScore-module__3B8Ida__header",
  "progressForeground": "QualityScore-module__3B8Ida__progressForeground",
  "scoreContainer": "QualityScore-module__3B8Ida__scoreContainer",
  "scoreInfo": "QualityScore-module__3B8Ida__scoreInfo",
  "scoreLabel": "QualityScore-module__3B8Ida__scoreLabel",
  "scoreTrack": "QualityScore-module__3B8Ida__scoreTrack",
  "scoreValue": "QualityScore-module__3B8Ida__scoreValue",
});
